module.exports = __webpack_public_path__ + "static/media/GSTImage.fe33f293.png";